export function isDateWithinNext10Days(
  checkInDate: string | null | undefined,
  timeZone: string = "America/New_York"
): boolean {
  if (!checkInDate || checkInDate.trim() === "") {
    return false;
  }

  const dateRegex = /^\d{8}$/;
  if (!dateRegex.test(checkInDate)) {
    return false;
  }

  const year = parseInt(checkInDate.slice(0, 4), 10);
  const month = parseInt(checkInDate.slice(4, 6), 10);
  const day = parseInt(checkInDate.slice(6, 8), 10);
  const formatDate = (
    date: Date
  ): { year: number; month: number; day: number } => {
    const formatter = new Intl.DateTimeFormat("en-US", {
      timeZone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });

    const parts = formatter.formatToParts(date);
    const partMap: Record<string, string> = {};
    parts.forEach((part) => {
      if (part.type !== "literal") {
        partMap[part.type] = part.value;
      }
    });

    return {
      year: parseInt(partMap.year, 10),
      month: parseInt(partMap.month, 10),
      day: parseInt(partMap.day, 10),
    };
  };

  const todayParts = formatDate(new Date());
  const today = new Date(todayParts.year, todayParts.month - 1, todayParts.day);
  const inputDate = new Date(year, month - 1, day);

  // Normalize both dates to midnight
  today.setHours(0, 0, 0, 0);
  inputDate.setHours(0, 0, 0, 0);

  const diffMs = inputDate.getTime() - today.getTime();
  const diffDays = diffMs / (1000 * 60 * 60 * 24);
  return diffDays >= 0 && diffDays <= 10;
}

export function shouldShowTravelexBanner(reservations: any): boolean {
  if (!Array.isArray(reservations) || reservations.length === 0) {
    return false;
  }
  return reservations.some((reservation: any) => {
    const checkInDate = reservation.reservationDetails.checkInDate;
    return isDateWithinNext10Days(checkInDate);
  });
}

export const filterReservationsByCheckInDate = (reservations: any[]): any[] => {
  return reservations.filter((reservation) => {
    const checkInDateStr = reservation.reservationDetails.checkInDate;

    return isDateWithinNext10Days(checkInDateStr);
  });
};
